// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#download-success-modal{font-size:.875rem}#download-success-modal .modal-title{font-size:1.5rem;line-height:1.375}#download-success-modal .modal-title:after{content:\"✨\";display:inline-block;margin-left:.5rem}#download-success-modal .modal-body{padding-top:.75rem}#download-success-modal .modal-body p:first-child{margin-bottom:.75rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
